<template>
  <div class="background-grey">
       <navbar/>
       <div style="min-height:50vh">
          <detail/>
       </div>
       <!-- <footer2/> -->
       <vue-element-loading :active="loadingdetail" :is-full-screen="true"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import navbar from '../components/navbar'
import detail from '../components/detail'
import footer2 from '../components/footer2'

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
    }
  },
  components:{
      navbar,
      footer2,
      detail
  },
  computed: {
       ...mapState(["loadingdetail"]),
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.background-grey{
background : white;
}
</style>



// WEBPACK FOOTER //
// src/views/detail.vue